// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-list[data-v-d939c840] {\n  width: 100%;\n  margin-bottom: 25px;\n}\n.map-list .chart-map[data-v-d939c840] {\n  width: 100%;\n  height: 600px;\n}\n.map-list .darkBg[data-v-d939c840] {\n  background: #001a3a;\n}\n.map-list .darkBg[data-v-d939c840] .ant-card-head-title {\n  color: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
